module.exports = __webpack_public_path__ + "media/images/the_tie_logo_white-af68e6dadff2361a783f631eea4e71d6.svg";